module.exports = __webpack_public_path__ + "img/user-profile.56a47b5a.svg";